import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { useRouter } from 'vue-router';
import AppBar from './components/general/AppBar.vue';
import { useSurveyResponseStore } from './stores/SurveyResponseStore';
import { computed, watch } from 'vue';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const surveyResponseStore = useSurveyResponseStore();

function refreshFolioInStore() {
  const id = router.currentRoute.value.params.id as string;
  if (!id) {
    surveyResponseStore.setId(null);
    return;
  }
  
  if (id === String(surveyResponseStore.id))
    return;

  if (id === 'new')
    surveyResponseStore.setId(id);
  else
    surveyResponseStore.setId(Number(id));
}

const showAppBar = computed(() => {
  return router.currentRoute.value.name !== 'login';
})

watch(router.currentRoute, () => {
  refreshFolioInStore();
}, { deep: true })

onMounted(() => {
  refreshFolioInStore();
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createBlock(_component_v_layout, { class: "hv-100" }, {
    default: _withCtx(() => [
      (showAppBar.value)
        ? (_openBlock(), _createBlock(AppBar, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, { class: "h-100" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, { class: "pa-2" }),
          _createVNode(_component_v_overlay, {
            absolute: "",
            class: "align-center justify-center",
            "model-value": _unref(surveyResponseStore).fetchingSurveyInfo
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                color: "primary",
                indeterminate: "",
                size: "32"
              })
            ]),
            _: 1
          }, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})